// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-profile-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 40px;
  margin-top: 13px;
  margin-right: 17px;
  width: 100%; /* Make it responsive */
  z-index: 1000;
}

.search-bar {
  display: flex;
  align-items: center;
  background-color: #EEEEEE;
  width: 215px;
  padding: 8px 15px;
  margin-right: 15px;
  border-radius: 50px;
  margin-right: auto; /* Pushes the search bar to the left */
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s ease;
}

.search-bar i {
  margin-right: 4px;
  color: #718096;
  transition: color 0.3s ease;
}

.search-bar input {
  border: none;
  outline: none;
  background: none;
  width: 150px;
  color: #666;
  transition: color 0.3s ease;
}

.header-icons {
  display: flex;
  align-items: center;
  position: relative; /* Position relative for dropdown */
}

.header-icons i {
  margin-right: 8px;
  margin-left: 8px;
  font-size: 20px;
  color: #666;
  cursor: pointer;
  transition: color 0.3s ease;
}

.icon-wrapper {
  padding: 4px;
  position: relative;
}

.icon-wrapper i {
  color: #2D3748;
}

.icon-wrapper:hover i {
  color: #5e17eb; /* Darker on hover */
}
.custom-tooltip {
  position: absolute;
  background-color: #5e17eb;
  color: white;
  padding: 6px 12px;
  border-radius: 4px;
  top: 120%;
  left: 50%;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); /* Optional: adds depth */
  transform: translateX(-50%);
  white-space: nowrap;
  z-index: 100;
  display: block;
  margin-top: 2px;
  font-size: 12px;
}

.profile-circle {
  background-color: #0b1a5b;
  color: #fff;
  width: 30px;
  height: 30px;
  font-size: 14px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  cursor: pointer;
  position: relative;
  transition: background-color 0.3s ease;
}

.profile-circle:hover {
  background-color: #253286;
}

.profile-dropdown {
  position: absolute;
  top: 50px;
  right: 0;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 200px;
  padding: 10px;
  z-index: 1000;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.dropdown-header {
  font-weight: bold;
  margin-bottom: 10px;
}

.dropdown-item {
  padding: 10px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.dropdown-item:hover {
  background-color: #f0f0f0;
  border-radius: 8px;
}

.logout {
  color: red;
  margin-top: 10px;
  font-weight: bold;
}

.settings-panel {
  position: fixed;
  top: 70px;
  right: 8px;
  width: auto;
  min-width: 250px;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 1001;
  padding: 10px;
}

.settings-panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.settings-header {
  font-size: 14px;
  font-weight: bold;
}

.close-settings-panel {
  background: #0b1a5b;
  border-radius: 25px;
  font-size: 10px;
  color: white;
  width: 20px;
  height: 20px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.settings-form .form-group {
  margin-bottom: 0px;
}

.form-group {
  font-size: 14px;
}

.settings-form label {
  display: block;
  margin-bottom: 5px;
  font-size: 12px;
  color: #333;
}

.settings-form input {
  width: 100%;
  padding: 8px;
  font-size: 12px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-sizing: border-box;
}

/* Notification Dropdown */
.notification-screen {
  position: absolute;
  top: 50px; /* Adjusts dropdown below the icons */
  right: 0; /* Aligns dropdown to the right edge of the screen/container */
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 300px;
  padding: 10px;
  z-index: 1000;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.notification-badge {
  background-color: red;
  color: white;
  font-size: 10px;
  padding: 2px 4px;
  border-radius: 50%;
  position: absolute;
  right: 10px;
  font-weight: bold;
  line-height: 1;
}

/* Triangle arrow pointing upwards */
.arrow-up {
  position: absolute;
  top: -10px; /* Position the arrow just above the dropdown */
  right: 142px; /* Adjust this to center the arrow below the notification icon */
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #fff; /* Same as the dropdown background */
  z-index: 1001;
}

.notification-screen h4 {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: bold;
}

.notification-screen ul {
  list-style-type: none;
  padding-left: 0;
}

.notification-screen li {
  padding: 10px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.notification-screen li:hover {
  background-color: #f0f0f0;
  border-radius: 8px;
}

.notification-time {
  font-size: 12px;
  font-weight: bold;
  color: #555;
  margin-bottom: 5px;
}

.notification-message {
  font-size: 14px;
  color: #333;
  margin-bottom: 5px;
  word-wrap: break-word; /* Ensure long text wraps to the next line */
  overflow-wrap: break-word; /* Ensures proper word breaking */
  word-break: break-all; /* Break long words to fit within the box */
}

/* Dark Mode Styles */
body.dark-mode {
  background-color: #2e2e2e;
  color: #ffffff;
}

body.dark-mode .icon-wrapper i {
  color: #8ab4f8;
}

body.dark-mode .search-bar {
  background-color: #666666;
}

body.dark-mode .search-bar input {
  color: #ffffff;
}


body.dark-mode .header-icons i {
  color: #ffffff;
}

body.dark-mode .icon-wrapper:hover i {
  color: #5e17eb; /* Darker on hover */
}

body.dark-mode .profile-circle {
  background-color: #888888;
}

body.dark-mode .profile-dropdown {
  background-color: #444444;
  color: #ffffff;
}

body.dark-mode .dropdown-item {
  color: #ffffff;
}

body.dark-mode .dropdown-item:hover {
  background-color: #555555;
}

body.dark-mode .dropdown-item.logout {
  color: #ff5555;
}

body.dark-mode .settings-panel {
  background-color: #444444;
  color: #ffffff;
  border: 0px solid #ccc;
}

body.dark-mode .notification-screen {
  background-color: #444444;
}

body.dark-mode .notification-screen li {
  color: #ffffff;
}

body.dark-mode .notification-screen li:hover {
  background-color: #555555;
}

body.dark-mode .arrow-up{
  border-bottom: 10px solid #555555;
}
.dark-mode .notification-time {
  color: #bbb; /* Lighter color for time */
}

.dark-mode .notification-message {
  color: #ddd; /* Lighter color for message */
}

.dark-mode .notification-badge {
  background-color: #ff5555; /* Slightly lighter red for dark mode */
  color: #000; /* Darker text color for badge */
}


.dropdown-item {
  padding: 8px 12px;
  cursor: pointer;
}

.dropdown-item:hover {
  background-color: #f0f0f0;
}

.dropdown-submenu {
  margin-top: 10px;
  padding-left: 12px;
  border-top: 1px solid #ddd;
}

.dark-mode-toggle {
  margin-left: 10px;
  cursor: pointer;
  padding: 5px 10px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
}

.dark-mode-toggle:hover {
  background-color: #0056b3;
}


@media (min-width: 120px) {
.header-icons {
  padding: 4px;
  background-color: #E6E6FA;
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1), 0 2px 10px rgba(0, 0, 0, 0.05);
}
body.dark-mode .header-icons {
  background-color: #2c2c2c;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
}
}`, "",{"version":3,"sources":["webpack://./src/components/Searchbar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,WAAW,EAAE,uBAAuB;EACpC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB,EAAE,sCAAsC;EAC1D,8CAA8C;EAC9C,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB,EAAE,mCAAmC;AACzD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc,EAAE,oBAAoB;AACtC;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,0CAA0C,EAAE,yBAAyB;EACrE,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,sBAAsB;EACtB,mBAAmB;EACnB,wCAAwC;EACxC,YAAY;EACZ,aAAa;EACb,aAAa;EACb,uDAAuD;AACzD;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,SAAS,EAAE,qCAAqC;EAChD,QAAQ,EAAE,8DAA8D;EACxE,sBAAsB;EACtB,mBAAmB;EACnB,wCAAwC;EACxC,YAAY;EACZ,aAAa;EACb,aAAa;EACb,uDAAuD;AACzD;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,UAAU,EAAE,+CAA+C;EAC3D,YAAY,EAAE,gEAAgE;EAC9E,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,oCAAoC;EACpC,8BAA8B,EAAE,oCAAoC;EACpE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,qBAAqB,EAAE,4CAA4C;EACnE,yBAAyB,EAAE,iCAAiC;EAC5D,qBAAqB,EAAE,2CAA2C;AACpE;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc,EAAE,oBAAoB;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;AACnC;AACA;EACE,WAAW,EAAE,2BAA2B;AAC1C;;AAEA;EACE,WAAW,EAAE,8BAA8B;AAC7C;;AAEA;EACE,yBAAyB,EAAE,uCAAuC;EAClE,WAAW,EAAE,gCAAgC;AAC/C;;;AAGA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,wEAAwE;AAC1E;AACA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;AACA","sourcesContent":[".search-profile-bar {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  height: 40px;\n  margin-top: 13px;\n  margin-right: 17px;\n  width: 100%; /* Make it responsive */\n  z-index: 1000;\n}\n\n.search-bar {\n  display: flex;\n  align-items: center;\n  background-color: #EEEEEE;\n  width: 215px;\n  padding: 8px 15px;\n  margin-right: 15px;\n  border-radius: 50px;\n  margin-right: auto; /* Pushes the search bar to the left */\n  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);\n  transition: background-color 0.3s ease;\n}\n\n.search-bar i {\n  margin-right: 4px;\n  color: #718096;\n  transition: color 0.3s ease;\n}\n\n.search-bar input {\n  border: none;\n  outline: none;\n  background: none;\n  width: 150px;\n  color: #666;\n  transition: color 0.3s ease;\n}\n\n.header-icons {\n  display: flex;\n  align-items: center;\n  position: relative; /* Position relative for dropdown */\n}\n\n.header-icons i {\n  margin-right: 8px;\n  margin-left: 8px;\n  font-size: 20px;\n  color: #666;\n  cursor: pointer;\n  transition: color 0.3s ease;\n}\n\n.icon-wrapper {\n  padding: 4px;\n  position: relative;\n}\n\n.icon-wrapper i {\n  color: #2D3748;\n}\n\n.icon-wrapper:hover i {\n  color: #5e17eb; /* Darker on hover */\n}\n.custom-tooltip {\n  position: absolute;\n  background-color: #5e17eb;\n  color: white;\n  padding: 6px 12px;\n  border-radius: 4px;\n  top: 120%;\n  left: 50%;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); /* Optional: adds depth */\n  transform: translateX(-50%);\n  white-space: nowrap;\n  z-index: 100;\n  display: block;\n  margin-top: 2px;\n  font-size: 12px;\n}\n\n.profile-circle {\n  background-color: #0b1a5b;\n  color: #fff;\n  width: 30px;\n  height: 30px;\n  font-size: 14px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  cursor: pointer;\n  position: relative;\n  transition: background-color 0.3s ease;\n}\n\n.profile-circle:hover {\n  background-color: #253286;\n}\n\n.profile-dropdown {\n  position: absolute;\n  top: 50px;\n  right: 0;\n  background-color: #fff;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  width: 200px;\n  padding: 10px;\n  z-index: 1000;\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n.dropdown-header {\n  font-weight: bold;\n  margin-bottom: 10px;\n}\n\n.dropdown-item {\n  padding: 10px;\n  font-size: 14px;\n  color: #333;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.dropdown-item:hover {\n  background-color: #f0f0f0;\n  border-radius: 8px;\n}\n\n.logout {\n  color: red;\n  margin-top: 10px;\n  font-weight: bold;\n}\n\n.settings-panel {\n  position: fixed;\n  top: 70px;\n  right: 8px;\n  width: auto;\n  min-width: 250px;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  z-index: 1001;\n  padding: 10px;\n}\n\n.settings-panel-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.settings-header {\n  font-size: 14px;\n  font-weight: bold;\n}\n\n.close-settings-panel {\n  background: #0b1a5b;\n  border-radius: 25px;\n  font-size: 10px;\n  color: white;\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.settings-form .form-group {\n  margin-bottom: 0px;\n}\n\n.form-group {\n  font-size: 14px;\n}\n\n.settings-form label {\n  display: block;\n  margin-bottom: 5px;\n  font-size: 12px;\n  color: #333;\n}\n\n.settings-form input {\n  width: 100%;\n  padding: 8px;\n  font-size: 12px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  box-sizing: border-box;\n}\n\n/* Notification Dropdown */\n.notification-screen {\n  position: absolute;\n  top: 50px; /* Adjusts dropdown below the icons */\n  right: 0; /* Aligns dropdown to the right edge of the screen/container */\n  background-color: #fff;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  width: 300px;\n  padding: 10px;\n  z-index: 1000;\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n.notification-badge {\n  background-color: red;\n  color: white;\n  font-size: 10px;\n  padding: 2px 4px;\n  border-radius: 50%;\n  position: absolute;\n  right: 10px;\n  font-weight: bold;\n  line-height: 1;\n}\n\n/* Triangle arrow pointing upwards */\n.arrow-up {\n  position: absolute;\n  top: -10px; /* Position the arrow just above the dropdown */\n  right: 142px; /* Adjust this to center the arrow below the notification icon */\n  width: 0;\n  height: 0;\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  border-bottom: 10px solid #fff; /* Same as the dropdown background */\n  z-index: 1001;\n}\n\n.notification-screen h4 {\n  margin-bottom: 10px;\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.notification-screen ul {\n  list-style-type: none;\n  padding-left: 0;\n}\n\n.notification-screen li {\n  padding: 10px;\n  font-size: 14px;\n  color: #333;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.notification-screen li:hover {\n  background-color: #f0f0f0;\n  border-radius: 8px;\n}\n\n.notification-time {\n  font-size: 12px;\n  font-weight: bold;\n  color: #555;\n  margin-bottom: 5px;\n}\n\n.notification-message {\n  font-size: 14px;\n  color: #333;\n  margin-bottom: 5px;\n  word-wrap: break-word; /* Ensure long text wraps to the next line */\n  overflow-wrap: break-word; /* Ensures proper word breaking */\n  word-break: break-all; /* Break long words to fit within the box */\n}\n\n/* Dark Mode Styles */\nbody.dark-mode {\n  background-color: #2e2e2e;\n  color: #ffffff;\n}\n\nbody.dark-mode .icon-wrapper i {\n  color: #8ab4f8;\n}\n\nbody.dark-mode .search-bar {\n  background-color: #666666;\n}\n\nbody.dark-mode .search-bar input {\n  color: #ffffff;\n}\n\n\nbody.dark-mode .header-icons i {\n  color: #ffffff;\n}\n\nbody.dark-mode .icon-wrapper:hover i {\n  color: #5e17eb; /* Darker on hover */\n}\n\nbody.dark-mode .profile-circle {\n  background-color: #888888;\n}\n\nbody.dark-mode .profile-dropdown {\n  background-color: #444444;\n  color: #ffffff;\n}\n\nbody.dark-mode .dropdown-item {\n  color: #ffffff;\n}\n\nbody.dark-mode .dropdown-item:hover {\n  background-color: #555555;\n}\n\nbody.dark-mode .dropdown-item.logout {\n  color: #ff5555;\n}\n\nbody.dark-mode .settings-panel {\n  background-color: #444444;\n  color: #ffffff;\n  border: 0px solid #ccc;\n}\n\nbody.dark-mode .notification-screen {\n  background-color: #444444;\n}\n\nbody.dark-mode .notification-screen li {\n  color: #ffffff;\n}\n\nbody.dark-mode .notification-screen li:hover {\n  background-color: #555555;\n}\n\nbody.dark-mode .arrow-up{\n  border-bottom: 10px solid #555555;\n}\n.dark-mode .notification-time {\n  color: #bbb; /* Lighter color for time */\n}\n\n.dark-mode .notification-message {\n  color: #ddd; /* Lighter color for message */\n}\n\n.dark-mode .notification-badge {\n  background-color: #ff5555; /* Slightly lighter red for dark mode */\n  color: #000; /* Darker text color for badge */\n}\n\n\n.dropdown-item {\n  padding: 8px 12px;\n  cursor: pointer;\n}\n\n.dropdown-item:hover {\n  background-color: #f0f0f0;\n}\n\n.dropdown-submenu {\n  margin-top: 10px;\n  padding-left: 12px;\n  border-top: 1px solid #ddd;\n}\n\n.dark-mode-toggle {\n  margin-left: 10px;\n  cursor: pointer;\n  padding: 5px 10px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n}\n\n.dark-mode-toggle:hover {\n  background-color: #0056b3;\n}\n\n\n@media (min-width: 120px) {\n.header-icons {\n  padding: 4px;\n  background-color: #E6E6FA;\n  border-radius: 10px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1), 0 2px 10px rgba(0, 0, 0, 0.05);\n}\nbody.dark-mode .header-icons {\n  background-color: #2c2c2c;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);\n}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
